import React, { useId } from "react";

export type MemberStatusReasonKind = "suspend" | "unsuspend" | "delete" | "cancelRenewal" | "uncancelRenewal";

// CMP Dashboard (19) L6892-6898, L15347-15349 (Monday 13281341150).
export const memberStatusReasonCopy: Record<MemberStatusReasonKind, { label: string; placeholder: string }> = {
  suspend: { label: "Reason for Suspension", placeholder: "Enter the reason this member is being suspended" },
  unsuspend: { label: "Reason for Unsuspending", placeholder: "Enter the reason this member is being unsuspended" },
  delete: { label: "Reason for Deleting", placeholder: "Enter the reason this member is being deleted" },
  // CMP Dashboard (21) CD:15777-15778 (IF11 MB10).
  cancelRenewal: { label: "Reason for Cancelling Member Renewal", placeholder: "Enter the reason this member renewal is being cancelled" },
  uncancelRenewal: { label: "Reason for Uncancelling Member Renewal", placeholder: "Enter the reason this member renewal is being uncancelled" },
};
export const memberStatusReasonHelper = "This reason is saved to the Member Communication Log.";
export const memberStatusReasonRequiredError = "Please enter a reason.";

export type MemberStatusReasonFieldProps = {
  kind: MemberStatusReasonKind;
  value: string;
  error: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
};

/** Required reason inside the Suspend, Unsuspend and Delete Member pop-ups. */
const MemberStatusReasonField = ({ kind, value, error, disabled = false, onChange }: MemberStatusReasonFieldProps) => {
  const id = useId();
  const copy = memberStatusReasonCopy[kind];
  return (
    <div className="mt-[18px] flex w-full flex-col gap-[6px] text-left">
      <label htmlFor={id} className="text-[14px] font-bold leading-[normal] text-[#0A0A0A]">
        {copy.label} <span className="text-[#F0202E]">*</span>
      </label>
      <span id={`${id}-helper`} className="text-[13px] leading-[1.5] text-[#0A0A0A]">{memberStatusReasonHelper}</span>
      <textarea
        id={id}
        value={value}
        rows={3}
        disabled={disabled}
        required
        aria-invalid={error || undefined}
        aria-describedby={`${id}-helper${error ? ` ${id}-error` : ""}`}
        placeholder={copy.placeholder}
        onChange={(event) => onChange(event.target.value)}
        className="box-border min-h-[80px] w-full resize-y rounded-[8px] border bg-white px-[12px] py-[11px] font-['DM_Sans',sans-serif] text-[14px] text-[#0A0A0A] outline-none disabled:cursor-not-allowed disabled:bg-[#F7F7F8]"
        style={{ borderColor: error ? "#F21B1B" : "#9E9E9E" }}
      />
      {error && <span id={`${id}-error`} role="alert" className="text-[13px] text-[#F21B1B]">{memberStatusReasonRequiredError}</span>}
    </div>
  );
};

export default MemberStatusReasonField;
